/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// API cập nhật cấu hình lịch nhắc hồ sơ giấy tờ
const updateCalendarDocumentConfig = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.PUT_REMINDER_DOCUMENT_CONFIG),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateCalenderDocumentReminder = await CONSTANTS.FUNCTION.AXIOS.POST(
               CONSTANTS.URL.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.PUT_REMINDER_DOCUMENT_CONFIG,
               action.payload
            )
            updateCalenderDocumentReminder.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateCalenderDocumentReminder.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateCalenderDocumentReminder.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API cập nhật cấu hình lịch nhắc bảo dưỡng
const updateCalendarMaintananceConfig = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.PUT_REMINDER_MAINTANANCE_CONFIG),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateCalenderDocumentReminder = await CONSTANTS.FUNCTION.AXIOS.POST(
               CONSTANTS.URL.CALENDAR_REMINDER_CONFIG_TRANSPORTATION.PUT_REMINDER_MAINTANANCE_CONFIG,
               action.payload
            )
            updateCalenderDocumentReminder.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateCalenderDocumentReminder.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateCalenderDocumentReminder.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
export default {
   updateCalendarDocumentConfig,
   updateCalendarMaintananceConfig
}
